
import { all, fork, takeEvery } from 'redux-saga/effects';
import { MENU_SET_THEME } from '../actions';


export function* watchSetTheme() {
    yield takeEvery(MENU_SET_THEME, configureTheme);
}

function* configureTheme({ payload }: any) {
    const { theme } = payload;
    if (theme === 'dark') {
        document.documentElement.classList.add('dark')
    } else {
        document.documentElement.classList.remove('dark')
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchSetTheme)
    ]);
}